import { render } from "./footerComponent.vue?vue&type=template&id=7945a8c4&scoped=true"
const script = {}

import "./footerComponent.vue?vue&type=style&index=0&id=7945a8c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7945a8c4"]])

export default __exports__